import { CategoryGroup } from '../interfaces/card-data';
import * as Highcharts from 'highcharts';
import { Router } from '@angular/router';
import { ReusableFunctions } from './reusable-functions';

export namespace PerformanceCharts {
    export class PerformanceCharts {
        constructor(private router: Router, private reusableFunctions: ReusableFunctions) {}

        createNewAreaChart(
            yAxisText: string,
            seriesInfo: any[],
            routerinfo: string[],
            categoryGroup: string[] | CategoryGroup[],
            hasDrilldownAccsess: boolean,
            addTitleSuffix: boolean,
            subtitle: string,
            navFromUrl: string = '',
            isVolume: boolean
        ): Highcharts.Options {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ',',
                },
            });
            let _this = this;

            return {
                chart: {
                    type: 'area',
                    height: 550,
                    spacingBottom: 8,
                    spacingLeft: 0,
                    marginRight: 0,
                    spacingRight: 0,
                    spacingTop: 0,
                    events: {
                        load: function () {
                            if (hasDrilldownAccsess) {
                                var xAxis = this.xAxis[0];
                                var xTicks = xAxis.ticks;
                                var yAxis = this.yAxis[0];
                                var points = this.series[0].points;
                                points.forEach((pointInf, i) => {
                                    let point = pointInf as Highcharts.PointOptionsObject;
                                    if (xTicks[i]) {
                                        var label = xTicks[i].label.element;
                                        label.style.cursor = 'pointer';
                                        label.onclick = function (item) {
                                            if (hasDrilldownAccsess) {
                                                let dateInfo = point.description.split('-');
                                                let queryParams = {
                                                    year: dateInfo[0],
                                                    month: dateInfo[1],
                                                    selectedPeriod: dateInfo[1],
                                                    commType: 'All',
                                                };

                                                if (navFromUrl !== '') {
                                                    queryParams['navFromUrl'] = navFromUrl;
                                                }
                                                _this.router.navigate(routerinfo, {
                                                    queryParams,
                                                });
                                            }
                                        };
                                    }
                                });
                            }
                        },
                    },
                },
                navigation: {
                    buttonOptions: {
                        enabled: false,
                    },
                },
                credits: {
                    enabled: false,
                },
                legend: {},
                title: {
                    text: isVolume
                        ? 'LOANS FUNDED - ACTUALS VS PROJECTIONS (YTD)'
                        : 'UNITS - ACTUALS VS PROJECTIONS (YTD)',
                    align: 'left',
                    x: 10,
                    y: 30,
                    margin: 70,
                    style: {
                        fontSize: '13px',
                    },
                },
                subtitle: {
                    text: subtitle,
                    align: 'left',
                    x: 10,
                    y: 65,
                    style: {
                        fontSize: '28px',
                        fontWeight: 'bold',
                    },
                },
                xAxis: [
                    {
                        type: 'category',
                        categories: categoryGroup,
                        startOnTick: true,
                        labels: {
                            enabled: true,
                            style: {
                                fontSize: '10px',
                                color: '#666666',
                            },
                        },
                    } as Highcharts.XAxisOptions,
                ],
                yAxis: {
                    title: {
                        text: yAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    lineWidth: 1,
                },
                tooltip: {
                    style: {
                        fontFamily: 'Roboto',
                        fontSize: '12',
                        height: 12,
                    },
                    borderColor: 'white',
                    backgroundColor: 'white',
                    borderRadius: 7,
                    borderWidth: 1,
                    shared: true,
                    useHTML: true,
                    outside: false,
                    formatter: function () {
                        let tooltip = '';
                        const length = 2;
                        let previousPeriodLine = '';
                        let tooltipTotalName = '';
                        const tooltipTitle = this.points[0].point.options.description;
                        let total = 0;
                        this.points = this.points.reverse();

                        tooltip =
                            '<table style="border-collapse: collapse">' +
                            this.points.reduce(function (s, point, index) {
                                let toolText = '';
                                let seriesName = point.series.name;
                                let color = `color: ${point.color}`;

                                // // Tooltip title
                                if (index === 0) {
                                    s += `<div class="projections-actuals-container">
                                               <div class="projections-actuals-tooltip-title">
                                                   <div class="projections-actuals-title">${tooltipTitle}</div>
                                                <div class="projections-actuals-title" style="padding-right: 20px">${
                                                    isVolume ? 'Volume' : 'Units'
                                                }</div>
                                              </div>`;
                                    tooltipTotalName = 'Total';
                                }
                                if (true) {
                                    total += point.y;
                                    toolText = s += `<tr>
                                            <td style="padding-right: 15px; display: flex; font-weight: 500;">
                                                <div style="display: flex; justify-content: space-between" class="tooltip-aag-title">
                                                    <div class="tooltip-aag-icon" style='${color}'>•</div>
                                                    <div style="font-size: 12px; margin-right: 50px">${seriesName}:</div>
                                                </div>
                                            </td>
                                            <td style="text-align: center; font-weight: 400">
                                                <span style="display: inline-block; width: 65px; margin-bottom: 6px">${
                                                    isVolume
                                                        ? _this.reusableFunctions.formatMoney(
                                                              point.y
                                                          )
                                                        : point.y
                                                }</span>
                                            </td>
                                        </tr>`;
                                }

                                // Totals: Removed as part of NV-8743: https://ncinodev.atlassian.net/browse/NV-8743, keeping here in case we want to add it back in the future.
                                // if (index === length - 1 && isVolume) {
                                //     toolText =
                                //         s +
                                //         `<tr style="border-top: 1px solid #505D6F; line-height: 16px">
                                //             <td style="padding-right: 15px; display: flex; font-weight: 500" class="tooltip-aag-title">
                                //                 <div style="margin-left: 28px">${tooltipTotalName}:</div>
                                //             </td>
                                //             <td style="text-align: center; font-weight: 400">
                                //                 <span style="display: inline-block; width: 65px; margin-bottom: 6px">${
                                //                     isVolume
                                //                         ? _this.reusableFunctions.formatMoney(total)
                                //                         : total
                                //                 }</span>
                                //             </td>
                                //         </tr>` +
                                //         previousPeriodLine;
                                // }
                                return toolText;
                            }, '') +
                            '</table>';
                        return tooltip;
                    },
                } as Highcharts.TooltipOptions,
                plotOptions: {
                    area: {
                        lineColor: '#E5E5E5',
                        lineWidth: 4,
                    },
                    series: {
                        marker: {
                            enabled: false,
                            symbol: 'circle',
                        },
                    },
                },
                series: this.formatSeriesInfo(
                    seriesInfo,
                    routerinfo,
                    hasDrilldownAccsess,
                    addTitleSuffix,
                    navFromUrl
                ),
            };
        }

        formatSeriesInfo(
            seriesInfo: any[],
            routerinfo: string[],
            hasDrilldownAccsess: boolean,
            addTitleSuffix: boolean,
            navFromUrl: string
        ) {
            let series: Highcharts.SeriesAreaOptions[] = [];
            const _this = this;
            seriesInfo.forEach((category, index) => {
                series.push({
                    type: 'area',
                    name: category.name,
                    data: category.data,
                    color: category.color,
                    fillOpacity: 0.4,
                    lineColor: category.color,
                    index: seriesInfo.length - index - 1,
                    legendIndex: index,
                    cursor: hasDrilldownAccsess ? 'pointer' : 'default',
                    point: {
                        events: {
                            click: function (dataPointEvent) {
                                if (hasDrilldownAccsess) {
                                    let dataPoint = dataPointEvent.point as AreaChartDatapoint;
                                    let dateInfo = dataPoint.description.split('-');
                                    let queryParams = {
                                        year: dateInfo[0],
                                        month: dateInfo[1],
                                        selectedPeriod: dateInfo[1],
                                        //TODO: Remove 'slice' once the sproc is ready to get the whole word as type
                                        commType: category.name.slice(0, 1),
                                    };

                                    if (addTitleSuffix) {
                                        queryParams['titleSuffix'] = ': ' + category.name;
                                    }

                                    if (navFromUrl !== '') {
                                        queryParams['navFromUrl'] = navFromUrl;
                                    }

                                    _this.router.navigate(routerinfo, {
                                        queryParams: queryParams,
                                    });
                                }
                            },
                        },
                    },
                });
            });
            return series;
        }
    }
}
export interface AreaChartDatapoint extends Highcharts.PointOptionsObject {}
